import useShadow from "hooks/useShadow";

const WorksMarquee: React.FC = (props) => {
  const { shadowRef } = useShadow({
    classNames: "works-marquee__item",
    callback: ({ element, factor }) => {
      let per = 1 - factor;
      element.style.opacity = per.toString();
    },
    options: {
      scale: 1.7
    }
  });

  return (
    <div className="works-marquee" ref={shadowRef}>
      {Array.from({ length: 3 }).map((_, colId) => (
        <div className="works-marquee__col" key={colId}>
          <div className="works-marquee__item">
            <img src={require('images/works/card1.png')} alt="card" />
          </div>
          <div className="works-marquee__item">
            <img src={require('images/works/card2.png')} alt="card" />
          </div>
          <div className="works-marquee__item">
            <img src={require('images/works/card3.png')} alt="card" />
          </div>
          <div className="works-marquee__item">
            <img src={require('images/works/card4.png')} alt="card" />
          </div>
          <div className="works-marquee__item">
            <img src={require('images/works/card5.png')} alt="card" />
          </div>
          <div className="works-marquee__item">
            <img src={require('images/works/card3.png')} alt="card" />
          </div>
        </div>
      ))}
    </div>
  );
};

export default WorksMarquee;
